import { Link } from "react-router-dom";
import { useContext, useState } from "react";
import { CartContext } from "../CartContex";

const Product = (props) => {
    const [isAdding, setIsAdding] = useState(false);
    const { cart, setCart } = useContext(CartContext);
    const { product } = props;

    const addToCart = (event, product) => {
        //console.log(product);
        event.preventDefault();

        let _cart = { ...cart };
        if (!_cart.items) {
            _cart.items = {};
        }
        if (_cart.items[product.id]) {
            _cart.items[product.id] += 1;
        } else {
            _cart.items[product.id] = 1;
        }

        if (!_cart.totalItems) {
            _cart.totalItems = 0;
        }
        _cart.totalItems += 1;
        setCart(_cart);
        setIsAdding(true);
        setTimeout(() => {
            setIsAdding(false);
        }, 1000);

        // const cart = {
        //     items: {
        //         id: quantity
        //     },
        //   totalItems : totaltemsvalue
        // }

    }

    return (
        <Link to={`/products/${product.id}`} className="block max-w-xs sm:max-w-sm mx-auto my-4 p-4 bg-white shadow-lg rounded-lg transition duration-300 transform hover:scale-105">
        <img className="w-full h-auto rounded-md" src={product.image} alt={product.name} />
        <div className="mt-4 text-center">
            <h2 className="text-lg font-bold text-gray-800">{product.name}</h2>
            <span className="block text-sm text-gray-600 mt-2">Size: {product.size}</span>
        </div>
        <div className="flex flex-col sm:flex-row justify-between items-center mt-4">
            <span className="text-lg font-bold text-gray-700 mb-2 sm:mb-0">Price: ${product.price.toFixed(2)}</span>
            <button
                disabled={isAdding}
                onClick={(e) => { addToCart(e, product) }}
                className={`${isAdding ? 'bg-green-500' : 'bg-yellow-500'} py-2 px-4 rounded-full font-bold text-white transition duration-300 ease-in-out hover:bg-opacity-70 focus:outline-none`}
            >
                {isAdding ? 'ADDED' : 'ADD'}
            </button>
        </div>
    </Link>
    );
}

export default Product
